let reasons = ['Dermatitis', 'Dome-shaped head', 'Dystocia', 'Overgrown tooth', 'Undersized/Underdeveloped', 'Donate', 'Cull', 'Other'];
export {reasons}